import { render, staticRenderFns } from "./menuBoard.vue?vue&type=template&id=1cf731af&"
import script from "./menuBoard.vue?vue&type=script&lang=js&"
export * from "./menuBoard.vue?vue&type=script&lang=js&"
import style0 from "./menuBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports